import { useMemo, useRef, useState } from "react";
import { useNotification } from 'hooks'
import { Table } from 'components/core-ui/Table'
import { getColumns, getFilters } from './helpers'
import { makeCoreGetFileRequest, makeCoreGetRequest } from "utils/api";
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { toTableRowItems } from './serializers'
import { formatErrorMessage } from 'utils/formatting'
import { ViewActionIcon } from 'icons'
import { openPdfInNewTab } from "utils/helpers";
import s from '../../../commonStyles.modules.scss'
import {
  getParentSocietyOptions,
  getShopOptions
} from '../../api'
import { useNavigate } from 'react-router-dom'

const ReturnTrucks = () => {
  const [tableItems, setTableItems] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [totalCount, setTotalCount] = useState<number>(0)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)

  const lastRawListRef = useRef<any[] | null>(null)
  const { showNotification } = useNotification()

  const navigate = useNavigate()

  const { data: shopOptions } = getShopOptions(showNotification)
  const { data: parentSocietyOptions } = getParentSocietyOptions(showNotification)

  const filters = useMemo(
    () =>
      getFilters({
        shopOptions,
        parentSocietyOptions
      }),
    [
      shopOptions,
      parentSocietyOptions
    ]
  )

  const download = async id => {
    try {
      const response = await makeCoreGetFileRequest(`/shop-reception/ds-return-trucks/print/${id}`, {
        responseType: 'blob'
      })

      openPdfInNewTab(response)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la printare. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const columns = useMemo(() => getColumns(download), [])

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: '/shop-reception/ds-return-trucks',
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      lastRawListRef.current = response.list
      setTableItems(toTableRowItems(response.list))
      setTotalCount(response.page?.totalCount || 0)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  return (
    <div className={s.mainContainer}>
      <Table
        hideCheckbox
        columns={columns}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        rowActions={[
          {
            label: 'Detalii',
            labelColor: 'white',
            typographyVariant: 'medium',
            backgroundColor: '#16a085',
            desktopIcon: <ViewActionIcon />,
            onClick: (e, rowId) => {
              navigate(`/shop-reception/suppliers/package/trucksReturn/${rowId}`, { state: { list: lastRawListRef.current } })
            }
          }
        ]}
        rowActionsWidth="130px"
        filters={filters}
        filtersButtonLabel="Filtre"
        filtersLabel="Filtre"
        appliedFiltersLabel="Filtre aplicate"
        cancelFiltersButtonLabel="Anuleaza"
        applyFiltersButtonLabel="Aplica"
        rowsPerPage={10}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </div>
  )
}

export default ReturnTrucks
